import React from 'react';
import { PropTypes } from 'prop-types';
import SmoothScroll from 'smooth-scroll';

import { connectToJSContext } from '../utils.jsx';
import { getElementOffsetTop, getNavbarHeight } from '../helpers.jsx';

class ScrollToLink extends React.Component {
    constructor() {
        super();
        this.initializeSmoothScroll = this.initializeSmoothScroll.bind(this);
        this.state = { scrollFinished: false };
    }

    componentDidMount() {
        this.scroll = new SmoothScroll();
    }

    initializeSmoothScroll(e) {
        e.preventDefault();

        const href = e.target.getAttribute("href") || "";
        const scrollDestionationElement = document.getElementById(href.replace('#', ''));

        if (scrollDestionationElement) {
            this.scrollTo(scrollDestionationElement);
        }
    }

    scrollTo(element) {
        const scrollToY = getElementOffsetTop(element) - this.props.computeOffsetTop();
        const speed = this.props.animationTime || 0;

        this.scroll.animateScroll(scrollToY, null, { speed });

        setTimeout(() => {
            this.scrollFinished();
        }, speed);
    }

    scrollFinished() {
        if (this.props.callback) {
            this.props.callback();
        }
        this.setState(() => ({ scrollFinished: true } ));
    }

    render() {
        return (
            <a
                href={this.props.href}
                className={this.props.className + (this.state.scrollFinished ? ' scroll-finished' : '')}
                ref={(c) => this._link = c}
                onClick={this.initializeSmoothScroll}
                aria-label={this.props.label}
                title={this.props.label}
            >
                {this.props.children}
            </a>
        );
    }
}

ScrollToLink.defaultProps = {
    className: 'hs-smooth-scroll'
};

ScrollToLink.propTypes = {
    animationTime: PropTypes.number,
    computeOffsetTop: PropTypes.func.isRequired
};

const mapStateToProps = () => {
    return {
        computeOffsetTop: () => getNavbarHeight()
    };
};

export { mapStateToProps };
export default connectToJSContext(mapStateToProps)(ScrollToLink);



// WEBPACK FOOTER //
// ./components/scroll_to_link/index.jsx